import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	task     : { pending: [], complete: [] },
	reminder : { upcoming: [], history: [] }
};

export const collaborationSlice = createSlice({
	name     : 'collaboration',
	initialState,
	reducers : {
		getTaskRedux : (state, action) =>
		{
			state.task = { ...state.task, ...action.payload };
		},
		getReminderRedux : (state, action) =>
		{
			state.reminder = { ...state.reminder, ...action.payload };
		}
	}
});

export const { getTaskRedux, getReminderRedux } = collaborationSlice.actions;
export default collaborationSlice.reducer;